import { render, staticRenderFns } from "./textQr.vue?vue&type=template&id=20bd51ae&scoped=true"
import script from "./textQr.vue?vue&type=script&lang=js"
export * from "./textQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd51ae",
  null
  
)

export default component.exports